<template>
  <div class="home">
    <!-- <div v-if="!userIsAuthenticated">
      <Signin />
    </div> -->

    <!-- <div v-if="userIsAuthenticated" class="panel panel-primary"> -->
    <div class="panel-body">
      <div class="appTitleOverlay">
        <b-img :src="require('../assets/images/PtownViews2019_19.png')" fluid class="b-img" alt="Herring Cove" />
        <p class="bottomLeftSubTitle">Provincetown.app</p>
      </div>
    </div>
    <!-- </div> -->

  </div>
</template>

<script>
  // import PropertySearch from '@/components/PropertySearch.vue'
  import Signin from '@/components/User/Signin.vue'
  export default {
    name: 'Home',
    components: {
      Signin
    },
    computed: {
      userIsAuthenticated() {
        this.userName = this.$store.getters.user
        console.log('User Name: ', this.$store.getters.user)
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      }
    },
  }
</script>

<style scoped>
  /*********************************************************/
  /*********************************************************/
  /*              IMAGE TITLE OVERLAY CSS                  */
  /*********************************************************/
  /*********************************************************/
  .appTitleOverlay {
    position: relative;
    /*background: url(/images/css_textoverimage.jpg);*/
    /*width: 500px;
        height: 309px;*/
  }

  .bottomRightTitle {
    position: absolute;
    bottom: -0.4em;
    right: 0.5em;
    width: 225px;
    font-weight: bold;
    font-size: 3rem;
    text-align: right;
    color: #fff;
  }

  .bottomRightSubTitle {
    position: absolute;
    bottom: 0.05em;
    right: 1.2em;
    width: 200px;
    font-weight: bold;
    font-size: 150%;
    color: #fff;
  }

  .bottomLeftSubTitle {
    position: absolute;
    bottom: 0.05em;
    left: 1.2em;
    width: 200px;
    font-weight: bold;
    font-size: 150%;
    color: #fff;
  }
</style>